import { useState, useEffect, useCallback } from 'react';
import { Phone } from 'lucide-react';

const FloatingCallButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = useCallback(() => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [setIsVisible]);

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, [toggleVisibility]);

  return (
    <a
      href="tel:514-570-9802"
      className={`floating-call-button ${isVisible ? 'visible' : ''}`}
      aria-label="Appelez maintenant"
    >
      <Phone size={24} />
      <span className="floating-call-text">APPELEZ MAINTENANT</span>
    </a>
  );
};

export default FloatingCallButton;
